import React, { useEffect, useState } from "react";
import {
  read,
  clearOperationResult,
} from "../../store/renewal/renewalActions";
import { useDispatch, useSelector } from "react-redux";
import { Spin, Collapse, Row, Col, Space, Button, Typography, Tabs } from "antd";
import { useParams } from "react-router-dom";
import RenewalSummary from "./RenewalSummary";
import TextMessages from "./TextMessages";
import EmailMessages from "./EmailMessages";
import AgentNotes from "./AgentNotes";
import { BackButton } from "../shared/BackButton";
import ChangeStatusModal from "./ChangeStatusModal";
import openNotificationOperationResult from "../shared/openNotificationOperationResult";
import BulkUpdateModal from "./bulkUpdate/BulkUpdateModal";
import ReminderPreferencesPanel from "./ReminderPreferencesPanel";

const RenewalForm = () => {
  const { renewalKey } = useParams();

  //
  const [isChangeStatusModalOpen, setIsChangeStatusModalOpen] = useState(false);
  const [isAssignDrawerOpen, setIsAssignDrawerOpen] = useState(false);
  const [bulkActionType, setBulkActionType] = useState(null);

  const handleStatusChange = (data) => {
    console.log("Status changed:", data);
    // Add your save logic here
    setIsChangeStatusModalOpen(false);
  };

  //
  const dispatch = useDispatch();

  //
  const selected = useSelector((state) => state.renewal.selected);
  const loading = useSelector((state) => state.renewal.selectedLoading);
  const operationResult = useSelector(
    (state) => state.renewal.operationResult
  );

  //
  useEffect(() => {
    openNotificationOperationResult(operationResult, () =>
      dispatch(clearOperationResult())
    );
  }, [operationResult]);

  const getTextMessagesDeliveredSummary = (reason) => {
    if (!selected?.TextMessages) return "0(0)";
    const total = selected.TextMessages.filter(
      (msg) => msg.Reason === reason
    ).length;
    const delivered = selected.TextMessages.filter(
      (msg) => msg.Reason === reason && msg.DeliveryStatus === 4
    ).length;
    return `Delivered (${delivered} of ${total})`;
  };

  const getEmailsDeliveredSummary = (reason) => {
    if (!selected?.EmailMessages) return "0(0)";
    const total = selected.EmailMessages.filter(
      (msg) => msg.Reason === reason
    ).length;
    const delivered = selected.EmailMessages.filter(
      (msg) => msg.Reason === reason && msg.DeliveryStatus === 2
    ).length;
    return `Delivered (${delivered} of ${total})`;
  };

  const reloadReminder = () => {
    if (!renewalKey) return;
    dispatch(read(renewalKey));
  }

  const textMessagesPanelHeader = selected ? (
    <Row>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Text Messages ({selected.TextMessages.length})
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Reminder:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getTextMessagesDeliveredSummary(0, "Reminder")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Thank You:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getTextMessagesDeliveredSummary(1, "Thank You")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
    </Row>
  ) : (
    "Text Messages"
  );
  const emailMessagesPanelHeader = selected ? (
    <Row>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Emails ({selected.EmailMessages.length})
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Reminder:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getEmailsDeliveredSummary(5, "Reminder")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
      <Col xs={24} sm={24} md={8} lg={8} xl={8} xxl={8}>
        <Typography.Text>
          Thank You:{" "}
          {loading ? (
            <Spin size="small" />
          ) : (
            <Typography.Text>
              {getEmailsDeliveredSummary(6, "Thank You")}
            </Typography.Text>
          )}
        </Typography.Text>
      </Col>
    </Row>
  ) : (
    "Email Messages"
  );

  //
  const agentNotesPanelHeader = selected?.AgentNotes
    ? `Agent Notes (${selected.AgentNotes.length})`
    : "Agent Notes";

  //
  const defaultPanelKeys =
    selected?.AgentNotes.length == 0 ? ["1", "3"] : ["1", "2", "3"];

  //
  useEffect(() => {
    reloadReminder();
  }, [renewalKey, dispatch]);

  const handleEditAction = (actionType) => {
    setBulkActionType(actionType);
    setIsAssignDrawerOpen(true);
  };

  const items = [
    {
      key: "1",
      label: "Summary",
      children: (
        <RenewalSummary
          selected={selected}
          onEditAction={handleEditAction}
        />
      ),
    },
    {
      key: "2",
      label: agentNotesPanelHeader,
      children: <AgentNotes notes={selected?.AgentNotes} />,
    },
    {
      key: "3",
      label: textMessagesPanelHeader,
      children: <TextMessages messages={selected?.TextMessages} />,
    },
    {
      key: "4",
      label: emailMessagesPanelHeader,
      children: <EmailMessages messages={selected?.EmailMessages} />,
    },
  ];

  const generalTabContent = (
    <>
      <Row style={{ paddingBottom: 4 }}>
        <Col span={16}>
          <Row>
            <Col>
              <Space>
                <BackButton
                  onGoBackHandler={() => {
                    /*
                           parentRefreshHandler();
                        dispatch(clearSelectedAction()); 
                        */
                  }}
                />
                <Button
                  size="small"
                  disabled={loading}
                  loading={loading}
                  onClick={() => setIsChangeStatusModalOpen(true)}
                >
                  Change Status
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>
      <Spin spinning={!selected} delay={500}>
        {selected != null && (
          <Row>
            <Col span={24}>
              <Collapse
                defaultActiveKey={defaultPanelKeys}
                size="small"
                items={items}
              />
            </Col>
          </Row>
        )}
      </Spin>
      {bulkActionType && (
        <BulkUpdateModal
          open={isAssignDrawerOpen}
          onCancel={(shouldReload) => {
            setIsAssignDrawerOpen(false);
            setBulkActionType(null);
            if (shouldReload) {
              reloadReminder();
            }
          }}
          selectedRowRecords={selected ? [selected] : []}
          filteredSelectedRowsCount={1}
          actionType={bulkActionType}
        />
      )}
      <ChangeStatusModal
        isOpen={isChangeStatusModalOpen}
        onCancel={() => setIsChangeStatusModalOpen(false)}
        onSave={handleStatusChange}
        loading={loading}
        selected={selected}
      />
    </>
  );

  const tabItems = [
    {
      key: "1",
      label: "General",
      children: generalTabContent,
    },
    {
      key: "2",
      label: "Reminder Preferences",
      children: (
        <ReminderPreferencesPanel
          renewalKey={renewalKey}
          policyNumber={selected?.PolicyNumber}
        />
      ),
    },
    {
      key: "3",
      label: "Customer Policies",
      children: <div>Customer Policies</div>,
    },
  ];

  return <Tabs defaultActiveKey="1" type="card" size="small" items={tabItems} />;
};

export default RenewalForm;
